module.exports = __webpack_public_path__ + "static/media/event-img.2c2b5220.jpg";